import { render, staticRenderFns } from "./LabelsChoose.vue?vue&type=template&id=f24924cc&scoped=true&"
import script from "./labelsChoose.js?vue&type=script&lang=js&"
export * from "./labelsChoose.js?vue&type=script&lang=js&"
import style0 from "./LabelsChoose.vue?vue&type=style&index=0&id=f24924cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24924cc",
  null
  
)

export default component.exports